import {type DmsDataGridProps, Main} from '@dms/shared';

import {VehicleRentalDocuments} from '../VehicleRentalDocuments/VehicleRentalDocuments';

export function Documents(props: Pick<DmsDataGridProps, 'maximization'>) {
  return (
    <Main>
      <VehicleRentalDocuments maximization={props.maximization} />
    </Main>
  );
}
